<dialog-gala (clickClose)="hideModal()">
    <span gala-dialog-titre>{{ titre }}</span>

    <div class="mt-4 w-100 container">
        <div class="row">
            <div class="col-6">
                <select-gala #agentTitulaire [label]="lgTrad.AGENTTITU" [longlabel]="true" [options]="listeTitulaire"
                    bindLabel="NOMPRENOM" [searchable]="true" optSorted="ASC" (selected)="selectAgentTitulaire($event)"
                    (clear)="clearTitulaire()" />
            </div>
            <div class="col-6">
                <select-gala #agentBeneficiaire [label]="lgTrad.AGENTBENEF" [longlabel]="true"
                    [options]="listeBeneficiaire" bindLabel="NOMPRENOM" [searchable]="true" optSorted="ASC"
                    (clear)="clearBeneficiaire()" (selected)="selectAgentBeneficiaire($event)" />
            </div>
        </div>
        <div class="h-1em"></div>
    </div>

    <div class="d-inline-flex modal-body-filtre">
        @if(!aucuneDonnees && boHabilitation){
        <div>
            <div class="mt-3 container justify-content-center">
                <table class="table table-striped table-portefeuille">
                    <thead>
                        <tr>
                            <th>
                                <mat-checkbox class="tab-checkbox chekbox-nopadding checkbox-pfclient"
                                    (change)="changeAll($event)" />
                            </th>
                            @for(head of headElements;track head){
                            <th (click)="sortBy(head.tri)" class="align-middle"
                                [ngClass]="(head.sortable)?'cursor-hand text-center':'text-center cursor-arrow'">
                                {{head.libelle}}&nbsp;
                                @if(head.sortable){
                                <cp-icon-sort [col]="sColTri === head.tri" [boo]="booAscendant" />
                                }
                            </th>
                            }

                            <th>
                                <div class="rounded-circle tab-btn-filter" [hidden]="!isFiltreHidden">
                                    <i (click)="showHideFiltres()"
                                        class="fas fa-filter click animated rotateIn text-primary"></i>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(pfclient of listeElementsAff;track pfclient.IDSERVICE){
                        <tr>
                            <td>
                                @if(getTypeReferent(pfclient)!==''){
                                <mat-checkbox [id]="pfclient.IDSERVICE?.toString()"
                                    class="tab-checkbox chekbox-nopadding" [(ngModel)]="pfclient.SELECTED"
                                    [ngModelOptions]=" {standalone:true}" (ngModelChange)="checkContrat(pfclient)" />
                                }
                            </td>
                            <td></td>
                            <td class="td-nuchep">{{ pfclient.NUCHEP }}</td>
                            <td class="td-nom">{{ pfclient.CLIENT.NOM }}</td>
                            <td class="td-service">{{ pfclient.SERVICE }}</td>
                            <td class="td-interlocuteur">{{ pfclient.INTERLOCUTEUR }}</td>
                            <td class="td-orga">{{ getOrgaCode(pfclient) }}</td>
                            <td colspan="2" class="td-referent">{{ getTypeReferent(pfclient) }}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>

        <div class="filtre-modal" [hidden]="isFiltreHidden">
            <div class="chevron-modal" (click)="showHideFiltres()">
                <i class="fa fa-chevron-circle-left click animated rotateIn text-primary"></i>
            </div>
            <ul>
                <li class="titre">{{lgTradFiltre.FILTRER}} </li>
                <li>
                    <select-filtre #selectOrganisme [options]="filtreOrganisme" (selected)="filtrer()"
                        [placeholder]="lgTradFiltre.ORGANISME" optSorted="ASC" />
                </li>
                <li>
                    <select-filtre #selectService [options]="filtreService" (selected)="filtrer()"
                        [placeholder]="lgTradFiltre.SERVICE" optSorted="ASC" />
                </li>
                <li>
                    <select-filtre #selectClient [options]="filtreClient" (selected)="filtrer()"
                        [placeholder]="lgTradFiltre.CLIENT" optSorted="ASC" />
                </li>
                <li>
                    <select-filtre #selectAgent [options]="filtreTypeReferent" (selected)="filtrer()"
                        [placeholder]="lgTradFiltre.TYPEREFERENT" optSorted="ASC" />
                </li>
            </ul>
            <div class="total">{{translate.instant("FILTERS.TOTAL")}}<span>{{ getListeFiltree().length
                    }}</span></div>
        </div>
        }@else{
        @if(aucuneDonnees) {
        <div class="mt-5 w-100 justify-content-center">
            <p class="text-center">{{lgTrad.MSGNODATAS}}</p>
        </div>
        } @else {
        <div class="mt-5 w-100 justify-content-center">
            <p class="text-center">Aucune habilitation SIG commune entre ces agents</p>
        </div>
        }
        }
    </div>
    <paginator [invisible]="aucuneDonnees || !boHabilitation" [noPadding]="true" />
    <div gala-dialog-actions>
        @if(droitsAccess.write && boHabilitation){
        <button mat-stroked-button color="primary" (click)="onMoveClient()">{{lgTrad.ENR}}</button>
        }
        <button mat-stroked-button color="accent" (click)="hideModal()">{{lgTrad.RET}}</button>
    </div>
</dialog-gala>